declare global {
	interface Window {
		__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__?: number[];
		__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__?: number;
	}
}

type WebPanelChangesResult = {
	initialHeight: number;
	changes: number;
	finalHeight?: number;
};

export const convertWebPanelChanges = (): WebPanelChangesResult => {
	const heightChanges = window?.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__;
	const result: WebPanelChangesResult = {
		initialHeight: window?.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0,
		changes: heightChanges?.length || 0,
	};
	if (heightChanges?.length) {
		result.finalHeight = heightChanges[heightChanges.length - 1];
	}
	return result;
};
